import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { putRequest, getRequest } from '../../../requestUtils';
import LogisticsTab from '../LogisticsTab';
import CertificationsTab from '../CertificationsTab';
import ExpertiseTab from '../ExpertiseTab';
import ExperienceTab from '../ExperienceTab';
import ResponsibilitiesTab from '../ResponsibilitiesTab';
import SummaryTab from '../SummaryTab';
import TitleTabBar from '../TitleTabBar';
import './CreateProposal.scss';
var CreateProposal = /*#__PURE__*/function (_Component) {
  function CreateProposal(props) {
    var _this;
    _classCallCheck(this, CreateProposal);
    _this = _callSuper(this, CreateProposal, [props]);
    _this.state = {
      selectedTab: props.selectedTab || 0,
      activeTab: null,
      proposal: props.proposal,
      errors: {},
      unsaved_changes: false,
      resume: props.resume
    };
    _this.goBack = _this.goBack.bind(_this);
    _this.toggleTab = _this.toggleTab.bind(_this);
    _this.handleFormChange = _this.handleFormChange.bind(_this);
    _this.savePrevious = _this.savePrevious.bind(_this);
    _this.saveContinue = _this.saveContinue.bind(_this);
    _this.handleLeavePage = _this.handleLeavePage.bind(_this);
    _this.handleViewUpdate = _this.handleViewUpdate.bind(_this);
    return _this;
  }
  _inherits(CreateProposal, _Component);
  return _createClass(CreateProposal, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      var selectedTab = this.state.selectedTab;
      var validateOnLoad = this.props.validateOnLoad;
      // If we're here from the Review page, we want to validate the
      // entire proposal and display all errors for all tabs
      if (validateOnLoad) {
        this.saveProposal();
        this.setState({
          activeTab: 3
        });
      } else {
        this.setFormStep(selectedTab);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('beforeunload', this.handleLeavePage);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('beforeunload', this.handleLeavePage);
      // Force update to prevent react-sticky getBoundingClientRect error
      this.setState = function () {};
    }
  }, {
    key: "setFormStep",
    value: function setFormStep(index) {
      var tabs = this.props.tabs;
      var proposal = this.state.proposal;
      if (index < tabs.length) {
        proposal.form_step = tabs[index];
        this.setState({
          proposal: proposal
        });
      }
    }
  }, {
    key: "goBack",
    value: function goBack() {
      var _this$state = this.state,
        selectedTab = _this$state.selectedTab,
        activeTab = _this$state.activeTab;
      var index = selectedTab - 1;
      window.scrollTo(0, 0);
      if (activeTab <= selectedTab) {
        this.setState({
          activeTab: selectedTab
        });
      }
      this.handleViewUpdate(index);
    }
  }, {
    key: "goForward",
    value: function goForward() {
      var _this$state2 = this.state,
        selectedTab = _this$state2.selectedTab,
        activeTab = _this$state2.activeTab;
      var index = selectedTab + 1;
      window.scrollTo(0, 0);
      if (activeTab == null || activeTab <= selectedTab) {
        this.setState({
          activeTab: selectedTab
        });
        this.setFormStep(index);
      }
      this.setState({
        selectedTab: index
      });
    }
  }, {
    key: "toggleTab",
    value: function toggleTab(e, index) {
      var activeTab = this.state.activeTab;
      e.preventDefault();
      window.scrollTo(0, 0);
      if (activeTab === null || index > activeTab) {
        this.setFormStep(index);
      }
      this.handleViewUpdate(index);
    }
  }, {
    key: "handleFormChange",
    value: function handleFormChange(key, value) {
      var proposal = this.state.proposal;
      proposal[key] = value;
      this.setState({
        proposal: proposal,
        unsaved_changes: true
      });
    }
  }, {
    key: "handleViewUpdate",
    value: function handleViewUpdate(index) {
      var _this2 = this;
      var viewResumeUrl = this.props.viewResumeUrl;
      if (index === 0) {
        getRequest(viewResumeUrl, {}).then(function (_ref) {
          var data = _ref.data;
          _this2.setState({
            selectedTab: index,
            resume: data
          });
        })["catch"](function () {
          _this2.setState({
            selectedTab: index,
            resume: null
          });
        });
      } else {
        this.setState({
          selectedTab: index
        });
      }
    }
  }, {
    key: "saveProposal",
    value: function saveProposal() {
      var _this3 = this;
      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var _this$props = this.props,
        csrfToken = _this$props.csrfToken,
        proposalUrl = _this$props.proposalUrl;
      // Capture form_step before the async call — data.response from the server
      // is a plain serialized object that doesn't include the virtual form_step
      // attribute, so we must restore it after setState to avoid losing it.
      var currentFormStep = this.state.proposal.form_step;
      return putRequest(proposalUrl, this.state.proposal, csrfToken).then(function (_ref2) {
        var data = _ref2.data;
        if (url) {
          _this3.setState({
            unsaved_changes: false
          }, function () {
            window.location.href = url;
          });
          return {};
        }
        _this3.setState({
          resume: data.resume,
          proposal: _objectSpread(_objectSpread({}, data.response), {}, {
            form_step: currentFormStep
          }),
          errors: data.errors,
          unsaved_changes: false
        });
        return data.errors || {};
      })["catch"](function (err) {
        _this3.setState({
          errors: err
        });
        // Return null (not {}) to distinguish a failed request from a successful
        // save that returned no validation errors — callers must not navigate on null.
        return null;
      });
    }
  }, {
    key: "savePrevious",
    value: function savePrevious() {
      var _this4 = this;
      this.saveProposal().then(function (errors) {
        if (errors === null) return;
        _this4.goBack();
      });
    }
  }, {
    key: "saveContinue",
    value: function saveContinue() {
      var _this5 = this;
      var tabs = this.props.tabs;
      var _this$state3 = this.state,
        proposal = _this$state3.proposal,
        selectedTab = _this$state3.selectedTab;
      // form_step is not set when validateOnLoad is true (review flow); fall back
      // to the currently selected tab so Save/Next gating works in both flows.
      var stepName = proposal.form_step || tabs[selectedTab] || '';
      var formStepKey = stepName.toLowerCase().replace(/\s+/g, '_');
      this.saveProposal().then(function (errors) {
        // null means the request failed (network/server error) — do not navigate
        if (errors === null) return;
        // If we cannot confidently determine the current step, do not navigate.
        if (!formStepKey) return;
        // Treat a missing count key as "unknown" — block navigation rather than
        // assuming zero errors (backend may not have run that step's validations).
        var stepErrorsKey = "".concat(formStepKey, "_errors_count");
        if (!Object.prototype.hasOwnProperty.call(errors, stepErrorsKey)) return;
        var stepErrors = errors[stepErrorsKey];
        if (stepErrors === 0) {
          _this5.goForward();
        }
      });
    }
  }, {
    key: "handleLeavePage",
    value: function handleLeavePage(e) {
      if (this.state.unsaved_changes === true) {
        var confirmationMessage = 'You have some unsaved changes. Are you sure you want to leave?';
        e.returnValue = confirmationMessage;
        return confirmationMessage;
      }
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;
      var _this$state4 = this.state,
        selectedTab = _this$state4.selectedTab,
        activeTab = _this$state4.activeTab,
        proposal = _this$state4.proposal,
        errors = _this$state4.errors,
        resume = _this$state4.resume;
      var _this$props2 = this.props,
        project = _this$props2.project,
        tabs = _this$props2.tabs,
        tabTitles = _this$props2.tabTitles,
        nonCompeteUrl = _this$props2.nonCompeteUrl,
        viewResumeUrl = _this$props2.viewResumeUrl,
        uploadResumeUrl = _this$props2.uploadResumeUrl,
        csrfToken = _this$props2.csrfToken,
        redirectUrl = _this$props2.redirectUrl,
        invitedToProject = _this$props2.invitedToProject,
        userId = _this$props2.userId,
        bio = _this$props2.bio,
        screeningAnswers = _this$props2.screeningAnswers,
        showBackgroundCheck = _this$props2.showBackgroundCheck;
      return /*#__PURE__*/React.createElement("div", {
        className: "proposal-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "save-and-continue-later-container"
      }, /*#__PURE__*/React.createElement("a", {
        role: "button",
        tabIndex: 0,
        key: "save",
        type: "button",
        id: "save-and-continue-later",
        className: "body-text-3 medium",
        onClick: function onClick() {
          return _this6.saveProposal(redirectUrl);
        }
      }, "SAVE & CONTINUE LATER")), /*#__PURE__*/React.createElement(TitleTabBar, {
        title: "Proposal Draft",
        tabs: tabs,
        tabTitles: tabTitles,
        toggleTab: this.toggleTab,
        selectedTab: selectedTab,
        activeTab: activeTab,
        errors: errors
      }), /*#__PURE__*/React.createElement("div", {
        className: "card p-5 border-0"
      }, /*#__PURE__*/React.createElement("div", {
        className: "tab-container"
      }, function () {
        switch (tabs[selectedTab]) {
          case 'Summary':
            return /*#__PURE__*/React.createElement(SummaryTab, {
              bio: bio,
              project: project,
              proposal: proposal,
              onFormChange: _this6.handleFormChange,
              errors: errors,
              resume: resume,
              deleteResume: _this6.deleteResume,
              viewResumeUrl: viewResumeUrl,
              uploadResumeUrl: uploadResumeUrl,
              csrfToken: csrfToken,
              userId: userId
            });
          case 'Responsibilities':
            return /*#__PURE__*/React.createElement(ResponsibilitiesTab, {
              project: project,
              proposal: proposal,
              onFormChange: _this6.handleFormChange,
              errors: errors
            });
          case 'Expertise':
            return /*#__PURE__*/React.createElement(ExpertiseTab, {
              project: project,
              proposal: proposal,
              onFormChange: _this6.handleFormChange,
              errors: errors,
              csrfToken: csrfToken,
              screeningAnswers: screeningAnswers
            });
          case 'Experience':
            return /*#__PURE__*/React.createElement(ExperienceTab, {
              project: project,
              userId: userId,
              proposal: proposal,
              onFormChange: _this6.handleFormChange,
              resume: resume,
              deleteResume: _this6.deleteResume,
              viewResumeUrl: viewResumeUrl,
              errors: errors,
              uploadResumeUrl: uploadResumeUrl,
              csrfToken: csrfToken
            });
          case 'Certifications':
          case 'Education':
            return /*#__PURE__*/React.createElement(CertificationsTab, {
              project: project,
              proposal: proposal,
              onFormChange: _this6.handleFormChange,
              errors: errors
            });
          case 'Logistics':
            return /*#__PURE__*/React.createElement(LogisticsTab, {
              project: project,
              proposal: proposal,
              onFormChange: _this6.handleFormChange,
              errors: errors,
              nonCompeteUrl: nonCompeteUrl,
              showBackgroundCheck: showBackgroundCheck
            });
          default:
            return null;
        }
      }(), /*#__PURE__*/React.createElement("div", {
        className: "actions"
      }, selectedTab > 0 && /*#__PURE__*/React.createElement("button", {
        type: "button",
        id: "create-proposal-back-tab-".concat(selectedTab),
        className: "btn btn-secondary back-btn",
        onClick: this.savePrevious
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-chevron-left me-3"
      }), tabs[selectedTab - 1]), selectedTab < tabs.length - 1 ? /*#__PURE__*/React.createElement("button", {
        key: "submit",
        type: "button",
        id: "create-proposal-continue-tab-".concat(selectedTab),
        className: "btn btn-primary next-btn right-side",
        onClick: this.saveContinue
      }, tabs[selectedTab + 1], /*#__PURE__*/React.createElement("i", {
        className: "fa fa-chevron-right ms-2"
      })) : /*#__PURE__*/React.createElement("button", {
        key: "save",
        type: "button",
        id: "create-proposal-review-tab-".concat(selectedTab),
        className: "btn btn-primary next-btn right-side",
        onClick: function onClick() {
          return _this6.saveProposal(redirectUrl);
        }
      }, "Review & Submit")))));
    }
  }]);
}(Component);
CreateProposal.propTypes = {
  proposal: PropTypes.shape({}).isRequired,
  bio: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
  project: PropTypes.shape({}).isRequired,
  csrfToken: PropTypes.string.isRequired,
  proposalUrl: PropTypes.string.isRequired,
  uploadResumeUrl: PropTypes.string.isRequired,
  resume: PropTypes.shape({}),
  viewResumeUrl: PropTypes.string.isRequired,
  nonCompeteUrl: PropTypes.string,
  tabs: PropTypes.arrayOf(PropTypes.string),
  tabTitles: PropTypes.arrayOf(PropTypes.string),
  redirectUrl: PropTypes.string.isRequired,
  validateOnLoad: PropTypes.bool,
  invitedToProject: PropTypes.bool,
  screeningAnswers: PropTypes.arrayOf(PropTypes.shape({})),
  selectedTab: PropTypes.number,
  showBackgroundCheck: PropTypes.bool
};
CreateProposal.defaultProps = {
  resume: null,
  nonCompeteUrl: null,
  tabs: ['Responsibilities', 'Experience', 'Certifications', 'Logistics'],
  tabTitles: ['Responsibilities', 'Experience', 'Certifications', 'Logistics'],
  validateOnLoad: false,
  invitedToProject: false,
  screeningAnswers: [],
  selectedTab: null,
  showBackgroundCheck: false
};
export default CreateProposal;